import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useOidc } from "@axa-fr/react-oidc";
import styles from "./Authentication.module.scss";
import { getAppConfig } from "services/configService";
import { loggedOut } from "actions/autologin.action";

const clearOidcCache = () => {
  try {
    const { authServerUrl } = getAppConfig();
    if (authServerUrl) {
      localStorage.removeItem(`oidc.server:${authServerUrl}/`);
    }
  } catch (error) {
    console.error("Failed to clear OIDC cache", error);
  }
};

const Logout = () => {
  const dispatch = useDispatch();
  const { logout } = useOidc();

  const handleLogout = useCallback(() => {
    sessionStorage.clear();
    clearOidcCache();
    dispatch(loggedOut());
    logout("/");
  }, [dispatch, logout]);

  useEffect(() => {
    handleLogout();
  }, [handleLogout]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src="/process.svg" alt="Signing out" className={styles.image} />
        <h1 className={styles.heading}>Signing you out</h1>
        <p className={styles.subtext}>
           Completing logout. You will be redirected shortly.
        </p>
      </div>
    </div>
  );
};

export default Logout;

